import { createEvent } from "signalstory";

export const SearchFilterChanged = createEvent<{ key: string, value: any }>('Search Filter Changed');
